import React, { useEffect, useState } from "react";
import { atom, useAtom } from "jotai";
import { useParams } from "react-router-dom";
import LoadPublicationData from "../components/analytics/LoadPublicationData";
import AnalyticsDashboard from "./AnalyticsDashboard";
import { BenchmarkData } from "../utils/types/dataTypes";

export const UNDEFINED = 0;

export const publicationIdAtom = atom<number>(UNDEFINED);
export const publicationTotalPagesAtom = atom<number>(UNDEFINED);
export const benchmarkCriteriaAtom = atom<BenchmarkData>({
	avgUniqueVisitors: UNDEFINED,
	avgDocVisits: UNDEFINED,
	avgPagesPerVisit: UNDEFINED,
	avgVisitTime: UNDEFINED
});

/**
 * Sets data for the analytics dashboard
 *
 * @constructor
 */
export const Analytics = () => {
	const [isLoadedPublication, setLoadedPublication] = useState(false);
	const [publicationId, setPublicationId] = useAtom(publicationIdAtom);
	const [publicationTotalPages, setPublicationTotalPages] = useAtom(publicationTotalPagesAtom);
	const [isPublicationIdLoaded, setIsPublicationIdLoaded] = useState(false);
	const [isBenchmarkCriteriaLoaded, setBenchmarkCriteriaLoaded] = useState(false);
	const [isPublicationTotalPagesLoaded, setPublicationTotalPagesLoaded] = useState(false);
	const [_, setBenchmarkCriteria] = useAtom(benchmarkCriteriaAtom);

	const params = useParams();

	useEffect(() => {
		const publicationId = params["publicationId"];
		const avgUniqueVisitors = params["avgUniqueVisitors"];
		const avgDocVisits = params["avgDocVisits"];
		const avgPagesPerVisit = params["avgPagesPerVisit"];
		const avgVisitTime = params["avgVisitTime"];
		const publicationTotalPages = params["publicationTotalPages"];

		if (publicationId) {
			setPublicationId(+publicationId);
			setIsPublicationIdLoaded(true);
		}
		if (avgUniqueVisitors &&
			avgDocVisits &&
			avgPagesPerVisit &&
			avgVisitTime) {
			const benchmarkCriteria: BenchmarkData = {
				avgUniqueVisitors: +avgUniqueVisitors,
				avgDocVisits: +avgDocVisits,
				avgVisitTime: +avgVisitTime,
				avgPagesPerVisit: +avgPagesPerVisit
			};
			setBenchmarkCriteria(benchmarkCriteria);
			setBenchmarkCriteriaLoaded(true);
		}
		if (publicationTotalPages) {
			setPublicationTotalPages(+publicationTotalPages);
			setPublicationTotalPagesLoaded(true);
		}
	}, []);

	return (
		<>
			{isPublicationIdLoaded &&
				<LoadPublicationData publicationId={publicationId}
									 publicationTotalPages={publicationTotalPages}
									 setLoaded={setLoadedPublication}/>}
			{isLoadedPublication && isBenchmarkCriteriaLoaded &&
				isPublicationTotalPagesLoaded && <AnalyticsDashboard/>}
		</>
	);
};

export default Analytics;
